import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "react-image-lightbox/style.css";
import "react-modern-drawer/dist/index.css";
import "react-phone-number-input/style.css";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.min.css";
import "react-day-picker/style.css";
import "./assets/Styles/style.css";
import "./assets/Styles/table.css";
import "swiper/css";
import ScrollToTop from "./helper/ScrollToTop";
import { Loader } from "./components/Core/Loader";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { routes } from "./routes";
import { useGetMe } from "hooks/useGetMe";
import { lazy, Suspense } from "react";
import ProtectedRouter from "helper/ProtectedRoute";

const NotFound = lazy(() => import("pages/NotFound"));

function App() {
  const userLoading = useGetMe();

  if (userLoading) {
    return <Loader className="vh-100" />;
  }

  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<Loader className={"vh-100"} />}>
          <Routes>
            {routes.map((route, index) => {
              return (
                <>
                  {Array?.isArray(route?.subMenu) ? (
                    route?.subMenu?.map((subRoute, subIndex) => {
                      return (
                        <Route
                          key={subIndex}
                          path={subRoute?.path}
                          exact={subRoute?.exact}
                          element={
                            <ProtectedRouter
                              element={subRoute?.element}
                              // isProtected={false} // For Development
                              isProtected={subRoute?.protected} // For Production
                            />
                          }
                        />
                      );
                    })
                  ) : (
                    <Route
                      key={index}
                      path={route?.path}
                      exact={route?.exact}
                      element={
                        <ProtectedRouter
                          element={route?.element}
                          // isProtected={false} // For Development
                          isProtected={route?.protected} // For Production
                        />
                      }
                    />
                  )}
                </>
              );
            })}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
